import { getName } from '@home/utils/common';
import { GAME_TYPE_ICON_MAP } from '../../../config/constant';
import { getAgentSourceIcon } from '@/pages/aigc/utils/getIcon';
import { channelInfo } from '@op/components/ChannelLabel';

/**
 * 获取筛选器选项的图标
 * 参考 SegmentCom.tsx 的图标处理逻辑
 */
export const getFilterOptionIcon = (
  dataKey: string,
  value: string,
  isActive: boolean,
  icon: string,
  // icon_active: string
): string | null => {
  let imgSrc: string | null = null;

  // 特殊处理不同类型的筛选器
  if (dataKey === 'game_type') {
    imgSrc = GAME_TYPE_ICON_MAP?.[value] || null;
  } else if (dataKey === 'source') {
    // 和产品核对后，只展示icon不展示icon_active
    imgSrc = getName(isActive, '', getAgentSourceIcon(value));
  } else if (dataKey === 'channel_name' || dataKey === 'channel') {
    imgSrc = channelInfo(value as any)?.img || null;
  }

  // 最终图标：优先使用特殊处理的 imgSrc，否则使用配置的 icon/icon_active
  // 和产品核对后，只展示icon不展示icon_active
  return imgSrc || getName(isActive, '', icon) || null;
};

/**
 * 判断是否为游戏类型筛选器
 */
export const isGameTypeFilter = (dataKey: string): boolean => dataKey === 'game_type';

